export default __webpack_public_path__ + "static/717-7cc12d6dab329677194804e6fadbfce0.gif";